import moment from 'moment';
import apolloClient from 'store/apolloClient';
import * as services from 'modules/appointmentsManagement/services/getOperationHours';
import apiCall from 'shared/utils/apiCall';
import createAsyncAction from 'shared/utils/createAsyncAction';
import errorAction from 'shared/utils/errorAction';
import createAction from './index';
import { FETCH_APPOINTMENT_CONTRACTS } from './fetchAppointmentContracts';

export const FETCH_OPERATING_HOURS = createAsyncAction(createAction('FETCH_OPERATING_HOURS'));

export const getOperationHours = (contractId, isWalkIn, momentDate) => dispatch => {
  dispatch({ type: FETCH_OPERATING_HOURS.pending });
  const startDate = momentDate || moment();
  const startDateValue = startDate.valueOf();

  const filter = isWalkIn ? {
    from: new Date().getTime(),
    to: moment().endOf('d').valueOf(),
  } : {
    from: moment(startDateValue).startOf('day').valueOf(),
    to: moment(startDateValue).add(1, 'month').valueOf(),
  };

  const apiCallParams = {
    query: services.FETCH_OPERATION_HOURS,
    fetchPolicy: 'no-cache',
    variables: {
      contractId,
      startTimestamp: filter.from,
      endTimestamp: filter.to,
    },
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then((response) => {
      const operationHours = response.data.getOperationHours;

      return dispatch({
        type: FETCH_OPERATING_HOURS.success,
        payload: operationHours.timeSlots,
      });
    })
    .catch((err) => {
      dispatch(errorAction(FETCH_APPOINTMENT_CONTRACTS.failure, err));

      throw err;
    });
};
